import emitPlaybackStatusChangeEvent from './emitPlaybackStatusChangeEvent';
import { DeliveryMode, Playback } from '../constants';
import { IPlugin } from '../interfaces';
import { ReporterSections } from '../Reporter/constants';
import { ErrorPlaybackModule } from '../BasePlugin';
import { dispatchUpdateReportEvent } from '../../events/dispatch';

const setToCDN = (plugin: IPlugin, error?: Error | string): void => {
  if (!plugin) {
    return;
  }
  const reason = error instanceof Error ? error.message : error || '';
  plugin.state.play.activeMode = DeliveryMode.NONE;
  emitPlaybackStatusChangeEvent({ plugin, reason });
  plugin.state.play.sdnPlaybackFailed = true;
  if (plugin.playbackModule) {
    if (typeof plugin.playbackModule.stop === 'function') {
      plugin.playbackModule.stop();
    }
    plugin.playbackModule = new ErrorPlaybackModule();
  }
  dispatchUpdateReportEvent({
    value: { playback: Playback.CDN },
    section: ReporterSections.General,
    override: true
  });
};

export default setToCDN;
